import { memo } from "react";
import { Card, CardContent, IconButton, Stack, Typography } from "@mui/material";
import Accordion from "@services/components/Accordion";
import { icon } from "@/app/style/icons";

interface WesentlichkeitsCardProps {
    title: string;
}

const WesentlichkeitsCard = memo(({ title }: WesentlichkeitsCardProps) => {
    return (
        <Card sx={{ p: 1.5 }}>
            <CardContent>
                <Typography variant={"h6"} fontSize={"1.2rem"}>
                    {title}
                </Typography>
            </CardContent>

            <CardContent>
                <Accordion title={"Wasserentnahme"} sx={{ background: "transparent" }} hideExpandIcon isHeader>
                    <Stack direction={"row"} alignItems={"center"} spacing={2.75} px={1.75}></Stack>
                </Accordion>

                <Accordion title={"Wasserentnahme"} subtitle={"ESRS E3"} details={"woiurvn"}>
                    <IconButton sx={{ mx: 3 }}>
                        <icon.check />
                    </IconButton>
                </Accordion>

                <Accordion title={"Wasserverbrauch"} subtitle={"ESRS E1"} details={"woiurvn"}>
                    <IconButton sx={{ mx: 3 }}>
                        <icon.check />
                    </IconButton>
                </Accordion>

                <Accordion title={"Ableitung von Wasser"} subtitle={"ESRS E2"} details={"woiurvn"}>
                    <IconButton color={"error"} sx={{ mx: 3 }}>
                        <icon.block />
                    </IconButton>
                </Accordion>

                <Accordion title={"Wasserentnahme"} subtitle={"ESRS E4"} details={"woiurvn"}>
                    <IconButton color={"error"} sx={{ mx: 3 }}>
                        <icon.block />
                    </IconButton>
                </Accordion>
            </CardContent>
        </Card>
    );
});

export default WesentlichkeitsCard;
